export default __webpack_public_path__ + "static/media/bazaar-logo-and-logotype 1.fb9f46a7.svg";